<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('fpaManage.permanent.fpaNo')" prop="fpaNo">
                  <!--FPA编号-->
                  <el-input v-model="queryCondition.fpaNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Product" prop="fpaName">
                  <!--FPA名称-->
                  <el-input v-model="queryCondition.fpaName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('fpaManage.permanent.agreementLife')" prop="agreementStartDate" class="flexBox">
                  <!--FPA有效期-->
                  <el-date-picker v-model="queryCondition.startDate" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd" :picker-options="AgreementPickerOptionsStart" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="To" prop="agreementEndDate" class="flexBox">
                  <el-date-picker v-model="queryCondition.endDate" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd" :picker-options="AgreementPickerOptionsEnd" style="width:100%"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Creator" prop="createUser">
                    <!--创建人-->
                    <el-input v-model="queryCondition.createUser" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Status" prop="status">
                    <!--状态-->
                    <ic-select clearable table="TT_FPA_LTO" field="STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData" type="primary">Search</el-button>
          <el-button size="mini" @click="restQueryFormThis" type="primary">Reset</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'Fold':'Unfold'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <el-table :data="tableList" ref="tableList" border highlight-current-row max-height='540' @selection-change="handleSelectChange">
      <el-table-column show-overflow-tooltip prop="serialNo" :label="$t('fpaManage.lto.serialNo')" min-width="120px">
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row.ttFpaLtoId)">{{scope.row.serialNo}}</div>
        </template>
      </el-table-column>
      <!--FPA编号-->
      <el-table-column show-overflow-tooltip prop="fpaNo" :label="$t('fpaManage.permanent.fpaNo')" min-width="100px">
      </el-table-column>
      <!-- FPA名称-->
      <el-table-column show-overflow-tooltip prop="fpaName" label="Product Or Commodity Purchased" min-width="250px"></el-table-column>
      <!--FPA有效期开始-->
      <el-table-column show-overflow-tooltip prop="agreementStartDate" :label="$t('fpaManage.permanent.agreementStartDate')" min-width="120px">
        <template slot-scope="scope">
          {{scope.row.agreementStartDate | dateFormatFilter("YYYY-MM-DD")}}
        </template>
      </el-table-column>
      <!--FPA有效期结束-->
      <el-table-column show-overflow-tooltip prop="agreementEndDate" :label="$t('fpaManage.permanent.agreementEndDate')" min-width="120px">
        <template slot-scope="scope">
          {{scope.row.agreementEndDate | dateFormatFilter("YYYY-MM-DD")}}
        </template>
      </el-table-column>
      <!--供应商简称-->
      <el-table-column show-overflow-tooltip prop="supplierAbbreviation" :label="$t('supplierManage.supplierAbbreviation')" min-width="180px"></el-table-column>
      <!--状态-->
      <el-table-column show-overflow-tooltip prop="statusValue" :label="$t('common.status')" min-width="80px"></el-table-column>
      <!--当前审批人-->
      <el-table-column show-overflow-tooltip prop="auditor" :label="$t('fpaManage.permanent.logicStatus')" min-width="100px"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import fpaLtoApi from "@/api/fpa/fpaLto";
import { fileService } from "@/api/common/file-utils";
import paginationMixin from '@/mixins/pagitionMixin';
import store from '@/store/index'

export default {
  components: { IcSelect },
  name: "fpaLtoList",
  mixins: [paginationMixin],

  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        fpaNo: '',
        fpaName: '',
        startDate: '',
        endDate: '',
        createUser: '',
        status: '',
        materialNo: '',
      },
      selectRow: [],
      tableList: [],
      totalCount: null,
      AgreementPickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      AgreementPickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.startDate;;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    };
  },
  created() {
    // this.queryData();
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    fpaLtoApi.fpaLtoList(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableList = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      fpaLtoApi.fpaLtoList(this.queryCondition).then(res => {
        this.tableList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    //选择操作
    handleSelectChange: function (row) {
      this.selectRow = row;
    },
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        fpaNo: '',
        fpaName: '',
        startDate: '',
        endDate: '',
        createUser: '',
        status: '',
        materialNo: '',
      }
      this.queryData();
    },
    toDetail(ttFpaLtoId) {
      this.$router.push({ name: 'fpaLtoDetail', params: { ttFpaLtoId: ttFpaLtoId } });
    },
  },
  extends: commonFunction
};
</script>
<style scoped  lang="scss">
.el-table {
  margin-top: 10px;
}
.el-select {
  width: 100%;
}
</style>
<style lang="scss">
.supplierCodeDialog .email.el-form-item .el-form-item__content {
  display: flex;
}
</style>
